// @flow
import _ from 'lodash';
import ko from 'rgs-knockout';
import type { Observable } from 'rgs-knockout';

export default class CheckboxSliderModel {
	constructor (options: {
		checked: Observable<boolean>,
		css: {},
	}) {

		this._options = _.defaults(options, {
			checked: ko.observable(false),
			css: {
				'nfd-checkbox-slider-control': true,
				'nfd-checkbox-slider-control-round': true,
				'nfd-checkbox-slider-control-active': options.checked,
			},
		});
	}
}
